import { addToast } from 'core/notifications';

export default ({ rows, source, destination, cacheKey, key, queryClient }) => {
  const sourceParentId = source.parentId;
  const sourceIndex = source.index;
  const destinationParentId = destination.parentId;
  const destinationIndex = destination.index;

  // Get the moved item ID
  const movedItemId = rows.items[destinationParentId].children[destinationIndex];

  // Remove the moved item from the destination
  rows.items[destinationParentId].children.splice(destinationIndex, 1);

  // Restore the moved item to its original position
  rows.items[sourceParentId].children.splice(sourceIndex, 0, movedItemId);

  queryClient.setQueryData(cacheKey, rows);

  return addToast(key, 'error');
};
